import { Footer as BeyondFooter, styled } from '@zeiss/beyond-online-react';
import { getOriginLegalLink, openInNewTab } from '@zeiss/lib-helpers';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  display: flex;
  align-items: flex-end;
`;

const legalNoticeLink = getOriginLegalLink('legalNotice');
const privacyNoticeLink = getOriginLegalLink('privacyNotice');
const publisherLink = getOriginLegalLink('publisher');

export const Footer = () => {
  const { t } = useTranslation(['common']);

  return (
    <Container>
      <BeyondFooter
        primaryContent={{
          actions: [
            {
              label: t('common:legal.publisher'),
              onClick: () => openInNewTab(publisherLink),
            },
            {
              label: t('common:legal.legalNotice'),
              onClick: () => openInNewTab(legalNoticeLink),
            },
            {
              label: t('common:legal.privacyNotice'),
              onClick: () => openInNewTab(privacyNoticeLink),
            },
          ],
          headline: t('common:legal.legal'),
        }}
        shellLayout="with-side-nav"
      />
    </Container>
  );
};
